import React, { useMemo } from 'react';
import styles from './receivedMessage.module.scss';
import { getImage, Image } from '../../utils/profileImage.util';
import avatar from '../../assets/images/DefaultAccountAvatar.svg';
import { Message } from '../../types/messages.types';
import cs from 'classnames';

interface Props {
  message: string;
  receiverId: number;
  profileImage?: Image | null;
  previousMessage?: Message;
}

const ReceivedMessage = ({
  message,
  profileImage = null,
  previousMessage,
  receiverId,
}: Props) => {
  const showAvatar = useMemo(() => {
    let result = true;
    if (previousMessage?.receiver === receiverId) {
      result = false;
    }
    return result;
  }, [previousMessage, receiverId]);
  return (
    <div className={styles.wrapper}>
      {showAvatar && (
        <div className={styles.avatarContainer}>
          <img src={getImage(profileImage, avatar)} alt="..." />
        </div>
      )}
      <div
        className={cs({
          [styles.container]: !showAvatar,
          [styles.containerWithAvatar]: showAvatar,
        })}
      >
        <div className={styles.textContainer}>
          <div className={styles.text}>{message}</div>
        </div>
      </div>
    </div>
  );
};

export default ReceivedMessage;
